import {
  PEOPLESOFT_TX_BOND_DATA_API,
  PEOPLESOFT_TX_BOND_ATTACHMENT_API,
  PEOPLESOFT_TX_SINGLE_BOND_DATA_API,
  PEOPLESOFT_TX_GET_USER_API,
  PEOPLESOFT_TX_GET_LAW_FIRM_API,
  REACT_APP_PEOPLESOFT_API,
  PEOPLESOFT_TX_UPLOAD_BOND_API, PROXY_API,
  PEOPLESOFT_TX_ADD_BOND_ATTACHMENT_API,
  SIGNED_URL_API,
  DELETE_FILE_API
} from "../creds";
import axios from 'axios';

export async function getBondsDataService(user_email, status) {
  try {

    const requestBody = {
      EmailID: user_email,
      Status: status
    };

    // Only add Status if provided
    // if (status) {
    //   requestBody.Status = status;
    // }

    const json = await postProxyService(
      PEOPLESOFT_TX_BOND_DATA_API,
      "POST",
      requestBody
    );

    return json;

  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export async function getBondsDataByIdService(bond_id, user_email) {
  try {
    const body = {
      bond_issue_number: bond_id,
      EmailID: user_email,
    };
    const response = await postProxyService(
      PEOPLESOFT_TX_SINGLE_BOND_DATA_API,
      "POST",
      body
    );
    console.log("getBondsDataByIdService---->", response);
    const data = response[0];
    if (data.Status == "Error" || data.StatusCode == "312") {
      console.error("Error fetching Bond:", data.Message);
      return {};
    }

    return data;
  } catch (error) {
    console.error("Error fetching Bond:", error);
    throw error;
  }
}

export async function updateAttachmentOnBond(request) {
  try {
    let updateBondRequest = {
      "IsUploadFlag": true,
      "Attachments": [request]

    }
    const json = await postProxyService(
      PEOPLESOFT_TX_BOND_ATTACHMENT_API,
      "POST",
      updateBondRequest
    );
    console.log(json);

    return json;
  } catch (error) {
    console.error("Error attaching file:", error);
    throw error;
  }
}

export async function updateMultipleAttachmentOnBond(request) {
  try {
    let updateBondRequest = {
      "IsUploadFlag": true,
      "Attachments": request

    }
    const json = await postProxyService(
      PEOPLESOFT_TX_BOND_ATTACHMENT_API,
      "POST",
      updateBondRequest
    );
    console.log(json);

    return json;
  } catch (error) {
    console.error("Error attaching file:", error);
    throw error;
  }
}

export async function getUserInformationService(user_role, law_firm) {
  try {
    console.log("getUserInformationService--->");
    console.log("user_role", user_role);
    console.log("law_firm", law_firm);
    const body = {
      user_role: user_role,
      law_firm: law_firm
    }
    const json = await postProxyService(
      PEOPLESOFT_TX_GET_USER_API,
      "POST",
      body
    );

    return json;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}

export async function getLawFirmInformationService() {
  try {
    const body = { getConfigType: "LAWFIRM" };
    const json = await postProxyService(
      PEOPLESOFT_TX_GET_LAW_FIRM_API,
      "POST",
      body
    );
    const lawFirm = json[0].LawFirm;
    return lawFirm;
  } catch (error) {
    console.error("Error fetching law firms:", error);
    throw error;
  }
}

export async function createNewAccountService(account_object) {
  try {
    const api_url =
      REACT_APP_PEOPLESOFT_API +
      "/TX_BOND_REGISTRATION.v1/CreateUserProfile/POST/";
    const response = await postProxyService(api_url, "POST", account_object);
    if (response[0].Status === 'Error.') {
      throw new Error(response[0].Message);
    }
    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error('Error creating account: ' + error.message);
  }
}

export async function postProxyService(URL, METHOD, BODY) {

  const requestBody = {
    apiUrl: URL,
    method: METHOD,
    body: BODY,
  };

  //console.log("proxy REQUEST", requestBody);

  try {
    const response = await fetch(PROXY_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json", // Ensure content type is JSON
      },
      body: JSON.stringify(requestBody), // Serialize the body to a JSON string
    });

    console.log("proxy response", response);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const json = await response.json();
    // console.log("proxy json", json);
    return json;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}

export async function uploadBondDataService(bondPageData) {
  try {
    const response = await postProxyService(
      PEOPLESOFT_TX_UPLOAD_BOND_API,
      "POST",
      bondPageData
    );
    console.log("uploadBondDataService--->", response);
    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

export async function addAttachmentToBond(requestDataArray) {
  try {
    console.log("sending bond data", requestDataArray);


    // Send the array in the body of the POST request
    const response = await postProxyService(
      PEOPLESOFT_TX_ADD_BOND_ATTACHMENT_API,
      "POST",
      requestDataArray
    );
    console.log("addAttachmentToBond response--->", response);
    return response;
  } catch (error) {
    console.error('Error addAttachmentToBond :', error);
    throw error; // Re-throw the error for external handling
  }
}



export async function getPresignedAttachmentUrl(id, attachment) {
  try {
    //const objectKeys = attachments.map(attachment => `${id}/${attachment.Attachment_Name}`);
    console.log("getPresignedAttachmentUrl-->");
    console.log("id", id);
    console.log("attachment", attachment);
    const objectKeys = [];
    const objectKey = `${id}/${attachment.Attachment_Name}`;
    objectKeys.push(objectKey);
    console.log('objectKeys--->', objectKeys);
    const response = await axios.post(
      SIGNED_URL_API,
      { objectKeys },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    const urlResponse = response.data.urls[0]
    console.log('getPresignedUrl--->', urlResponse);
    return urlResponse.presignedUrl;
  } catch (error) {
    console.error('Error in getPresignedUrl:', error);
    throw error;
  }
}

export function calculateFeeAmountDeu(principalAmount) {
  // Par Dollar Amount is principalAmount
  const feeFromPercentage = principalAmount * 0.001;
  // Use Math.min to cap the fee at $9,500 and Math.max to ensure it's at least $750
  const feeAmountDue = Math.max(Math.min(feeFromPercentage, 9500), 750);
  return feeAmountDue;
};


export async function deleteAttachmentOnBond(id, attachment) {
  try {
    const objectKey = `${id}/${attachment[0].Attachment_Name}`;
    const response = await axios.post(DELETE_FILE_API,
      { objectKey },
      {
        headers: {
          'Content-Type': 'application/json'
        },

      });

    console.log('File deleted successfully:', response.data);
  } catch (error) {
    console.error('Error deleting file:', error.response ? error.response.data : error.message);
  }
}

export async function deleteMultipleAttachmentsOnBond(id, attachmentsList) {
  try {
    const deletePromises = attachmentsList.map(att => {
      const objectKey = `${id}/${att.Attachment_Name}`;
      return axios.post(DELETE_FILE_API, 
        { objectKey },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
    });

    const results = await Promise.allSettled(deletePromises);

    results.forEach((result, index) => {
      if (result.status === 'fulfilled') {
        console.log(`File deleted successfully: ${attachmentsList[index].Attachment_Name}`);
      } else {
        console.error(`Error deleting file ${attachmentsList[index].Attachment_Name}:`, result.reason.response ? result.reason.response.data : result.reason.message);
      }
    });
  } catch (error) {
    console.error('Unexpected error during deletion:', error);
  }
}

export async function getBulkPresignedAttachmentUrl(objectKeys) {
  try {
    console.log("getBulkPresignedAttachmentUrl-->");
    console.log("objectKeys", objectKeys);
    const itsDownload = true;
    console.log("getBulkPresignedAttachmentUrl-->", SIGNED_URL_API,
      { objectKeys, itsDownload },
      {
        headers: { 'Content-Type': 'application/json' },
      });
    console.log(JSON.stringify({ objectKeys, itsDownload }))
    const response = await axios.post(
      SIGNED_URL_API,
      { objectKeys, itsDownload },
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
    // Expecting the Lambda to return a JSON object with a "body" property that is a base64-encoded ZIP
    const base64Zip = response.data;
    return base64Zip;
  } catch (error) {
    console.error('Error in getBulkPresignedAttachmentUrl:', error);
    throw error;
  }
}



export function validateEmail(userType, email) {
  // Define the patterns for each user type
  const emailPatterns = {
    "OAG": /@oag\.texas\.gov$/,
    "BRB": /@brb\.texas\.gov$/,
    "MAC": /@mactexas\.com$/,
    "CSL": /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    "TWB": /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    "TEA": /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  };

  // Check if the selected user type has a valid pattern
  if (!emailPatterns[userType]) {
    return { valid: false, message: "Invalid user type selected." };
  }

  // Validate the email address based on the selected user type
  const isValid = emailPatterns[userType].test(email);

  if (isValid) {
    return { valid: true, message: "Email address is valid." };
  } else {
    return { valid: false, message: `Invalid email address for user type ${userType}` };
  }
}